

export const formatToRandWithDecimalsString = (text: string | number): string => {
    // console.log('Format text: ', text)
    let formatted = text;
    if (typeof(text) === "number"){
        formatted = text.toFixed(2);
    }
    else
    {
        formatted = '0.00'
    }
    return `R ${formatted}`;
}

export const formatToRandWithNoDecimals = (text: string | number): string => {
    let formatted = text;
    if (typeof(text) === "number"){
        formatted = text.toFixed(0);
    }
    return `R ${formatted}`;
}